import React from 'react';

import ResourceLoader, { ResourceLoaderProps } from '../ResourceLoader';
import ContentLoader from '../ContentLoader';

export interface ContentResourceLoaderProps<Data, Error = {}> extends
ResourceLoaderProps<Data, Error> { }
/**
 * @mode developer
 */
const ContentResourceLoader = <Data, Error = {}>(props: ContentResourceLoaderProps<Data, Error>) => (
  <div data-testid="ContentResourceLoader">
    <ResourceLoader
      CustomLoader={ContentLoader}
      {...props}
    />
  </div>
);

ContentResourceLoader.publicProps = ResourceLoader.publicProps;

export default ContentResourceLoader;
